import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AddNewFacility } from '../../services/api';

// Async thunk for adding a new facility
export const addFacility = createAsyncThunk(
  'addFacility/add',
  async (facilityData, { rejectWithValue }) => {
    try {
      const response = await AddNewFacility(facilityData);
      return response.data;
    } catch (error) {
      // Return the error response data if available, otherwise return the error message
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  facilityData: null,
};

const addFacilitySlice = createSlice({
  name: 'addFacility',
  initialState,
  reducers: {
    resetFacilityState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.facilityData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addFacility.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addFacility.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.status === true;
        state.facilityData = action.payload;
        state.error = action.payload.status === false ? action.payload.message : null;
      })
      .addCase(addFacility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Something went wrong';
        state.success = false;
      });
  },
});

export const { resetFacilityState } = addFacilitySlice.actions;
export default addFacilitySlice.reducer; 